import React, { PureComponent } from 'react';

export default class TextAnchor extends PureComponent {
  state = { buttonShowing: false, justCreated: true };

  componentDidMount() {
    this.mounted = true;
    this.textBox.addEventListener('click', this.onClick);
    document.addEventListener('mousedown', this.onDocumentMouseDown);
    document.addEventListener('keydown', this.onDocumentKeyDown);

    setTimeout(() => {
      if (this.mounted) {
        this.setState({ ...this.state, justCreated: false });
      }
    }, 200);
  }

  componentWillUnmount() {
    this.mounted = false;
    this.textBox.removeEventListener('click', this.onClick);
    document.removeEventListener('mousedown', this.onDocumentMouseDown);
    document.removeEventListener('keydown', this.onDocumentKeyDown);
  }

  render() {
    const textAnchorStyle = {
      left: this.props.x + 'px',
      top: this.props.y + 'px',
    };
    if (this.props.rotate) {
      textAnchorStyle.transform = 'rotate(' + this.props.rotate + 'rad)';
    }

    // TODO: Re-work on the text alignment when work on the editing dimension
    textAnchorStyle.left = (this.props.axis === 'Y' ? this.props.x - 32 : this.props.x) + 'px';

    let size;
    const textBoxStyle = {};
    if (this.props?.textColorStyle?.fontSize) {
      size = parseInt(this.props.textColorStyle.fontSize);
      textBoxStyle['marginTop'] = size - 12 + 'px';
    }

    const className =
      'text-anchor' +
      (this.state.buttonShowing ? ' button-showing' : '') +
      (this.state.justCreated ? ' just-created' : '') +
      (this.props.axis ? ` line-axis-${this.props.axis}` : '');

    let measureTextStyle = {};
    if (this.props.textColorStyle) {
      measureTextStyle = JSON.parse(JSON.stringify(this.props.textColorStyle));
    }
    if (this.state.buttonShowing) {
      measureTextStyle['background-color'] = 'rgba(0, 0, 0, 0.2)';
    }

    const textWidth = (size + 24) + 'px';

    return (
      <div className={className} style={textAnchorStyle}>
        <div className="text-box" ref={(e) => (this.textBox = e)} style={textBoxStyle}>
          <div className="measurement-text" ref={(e) => (this.text = e)} style={measureTextStyle}>
            {this.state.buttonShowing && (
              <input
                type="text"
                value={this.props.textDisplay}
                onChange={(e) => this.props.changeTextVal(this.props.line, e.target.value)}
                style={{
                  width: textWidth,
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  color: this.props.textColorStyle.color,
                }}
              />
            )}
            {!this.state.buttonShowing && (
              <>
                {this.props.textDisplay}
                {this.props.measurementUnit ? ` ${this.props.measurementUnit}` : ''}
              </>
            )}
          </div>
          {this.state.buttonShowing && (
            <button
              // type="button"
              className="delete-button"
              onClick={this.onDeleteButtonClick}
              // Additional mouse-down handler means delete works cleanly if text is being edited:
              onMouseDown={this.onDeleteButtonClick}
              ref={(e) => (this.deleteButton = e)}>
              <svg className="delete-button-svg">
                <path
                  className="delete-button-icon"
                  d="M 4 4 L 11 11 M 11 4 L 4 11"
                  style={{ stroke: this.props.textColorStyle.color }}
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    );
  }

  onClick = () => {
    this.setState({ ...this.state, buttonShowing: this.props.isMeasureToolEditable });
    this.props.selectLine();
  }

  onDocumentMouseDown = (e) => {
    if (!this.textBox.contains(e.target)) {
      this.setState({ ...this.state, buttonShowing: false });
    }
  };

  onDocumentKeyDown = (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.setState({ ...this.state, buttonShowing: false });
    }
  };

  onDeleteButtonClick = (event) => {
    if (event.button === 0) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onDeleteButtonClick();
    }
  };
}
